import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var registry = {};
/**
 * Utility class exposing IEG Registry utilities.
 *
 * @namespace IEGRegistry
 */

var IEGRegistry = /*#__PURE__*/function () {
  function IEGRegistry() {
    _classCallCheck(this, IEGRegistry);
  }

  _createClass(IEGRegistry, null, [{
    key: "registerComboBoxSearchFunctions",

    /**
     * Register the IEG combobox search functions.
     *
     * @param {Object} comboBoxSearchFunctions Object that contains the named functions.
     * @memberof IEGRegistry
     */
    value: function registerComboBoxSearchFunctions(comboBoxSearchFunctions) {
      registry.comboBoxSearchFunctions = comboBoxSearchFunctions;
    }
    /**
     * Getsthe comboBoxSearchFunctions
     * @memberof IEGRegistry
     * @returns  The comboBoxSearchFunctions
     */

  }, {
    key: "comboBoxSearchFunctions",
    get: function get() {
      return _Object$assign({}, registry.comboBoxSearchFunctions);
    }
  }]);

  return IEGRegistry;
}();

export { IEGRegistry as default };